import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'redux/typings';
import { HelpState } from './typings';

const selectHelpState = (state: RootState) => state.help;

export const selectHelpQuestions = createSelector(
  selectHelpState,
  (help: HelpState) => help.questions,
);
